import { LOTTIE_LATE_INIT } from "./constants";

const $ = jQuery.noConflict();

export default function lottieInit() {
    $("[data-lottie]").each(function onEach(index, element) {
        if ($(element).hasClass(LOTTIE_LATE_INIT)) {
            return;
        }

        // eslint-disable-next-line no-undef
        lottie.loadAnimation({
            container: $(this)[0],
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: $(this).data("lottie"),
        });
    });

    // eslint-disable-next-line no-undef
    const animations = lottie.getRegisteredAnimations();

    $("[data-lottie]").each(function onEach(index, element) {
        // eslint-disable-next-line no-undef, no-new
        new Waypoint({
            element,

            handler() {
                for (const animation of animations) {
                    const $this = $(animation.wrapper);

                    if ($this[0] === element) {
                        animation.play();
                    }
                }
            },

            offset: "75%",
        });
    });
}
